import { useTranslations } from 'next-intl';
import { Image } from 'components/image';
import cx from 'classnames';
import styles from './selected-equipment.module.scss';
import { replaceTokensWithComponents } from '@cat-ecom/common/utils/stringUtils';
import { camelCase, startCase } from 'lodash';
import {
  CatButton,
  CatCheckboxField,
  CatHeading
} from 'components/blocks-components';
import type { SelectedEquipmentInfo as SelectedEquipmentInfoType } from 'app/[lang]/[esite]/(core)/_header/components/equipment-widget/types';
import { useMyEquipmentDrawer } from 'components/my-equipment/my-equipment-drawer-context';
import { useToggleFilterByEquipment } from '../../common';

const SelectedEquipmentWrapper = ({
  selectedEquipmentInfo
}: {
  selectedEquipmentInfo: SelectedEquipmentInfoType;
}) => {
  const t = useTranslations();

  const imgURL = selectedEquipmentInfo.imageURL + '?wid=60&hei=60&fmt=webp';
  const equipmentName = `${selectedEquipmentInfo.model} ${startCase(
    camelCase(selectedEquipmentInfo.productFamily)
  )}`;

  const checkBoxLabel = replaceTokensWithComponents(
    t('REFINE_RESULTS_FOR', { '0': '{0}' }),
    <strong>{selectedEquipmentInfo.model}</strong>
  );

  const { handleCheckboxChange, filterByEquipment } =
    useToggleFilterByEquipment(selectedEquipmentInfo);

  const { selectEquipmentDrawer } = useMyEquipmentDrawer();

  return (
    <div className="d-flex flex-column gap-3">
      <div className="d-flex flex-row justify-content-between w-100 align-items-start">
        <div className="d-flex flex-row ">
          <Image
            src={imgURL}
            width={60}
            height={60}
            alt={equipmentName}
            className={cx('me-2', styles['selected-equipment-wrapper__image'])}
            unoptimized
          />
          <div className="d-flex flex-column ms-1">
            <CatHeading level="h3" variant="title-sm">
              {selectedEquipmentInfo.assetId
                ? selectedEquipmentInfo.assetId
                : equipmentName}
            </CatHeading>
            {selectedEquipmentInfo.assetId && (
              <CatHeading level="h4" variant="footnote">
                {equipmentName}
              </CatHeading>
            )}
            {selectedEquipmentInfo.serialNumber && (
              <CatHeading level="h4" variant="footnote">
                {selectedEquipmentInfo.serialNumber}
              </CatHeading>
            )}
          </div>
        </div>
        <CatButton
          variant="ghost"
          className={styles['selected-equipment-wrapper__change-button']}
          onClick={selectEquipmentDrawer.openDrawer}
        >
          {t('CHANGE')}
        </CatButton>
      </div>
      <CatCheckboxField
        data-testid="filter-by-equipment-checkbox"
        className={styles['selected-equipment-wrapper__checkbox']}
        checked={filterByEquipment}
        onBlCheckboxChange={handleCheckboxChange}
      >
        {checkBoxLabel}
      </CatCheckboxField>
    </div>
  );
};
export default SelectedEquipmentWrapper;
